import {
  FilterEditorModalController
} from './filter-editor-modal.component';

export class FilterEditorModalService {
  constructor($timeout, $modal, $window) {
    this.$timeout = $timeout;
    this.$modal = $modal;
    this.window = angular.element($window);
    this.window.bind('resize', this.updateModalSize);
  }

  updateModalSize() {
    $('.modal-body1').height((window.innerHeight * 0.96 -
      $('.modal-header').outerHeight() -
      $('.modal-footer').outerHeight() + 5));
    const baseheight = $('.modal-body1').height() - $('#myTab').height();
    $('.aggregate-modal').height(baseheight);
  }

  open(model, filter, asNew, tabName) {
    this.modalInstance = this.$modal.open({
      // backdrop: 'static',
      // keyboard: false,
      templateUrl: 'filterDialog.html',
      controller: FilterEditorModalController,
      resolve: {
        asNew: () => asNew,
        filter: () => filter,
        model: () => model,
        tabName: () => tabName,
      },
      windowClass: 'filterDialog filterDialogLarge',
    });

    this.modalInstance.opened
      .then(() => {
        this.$timeout(() => {
          this.updateModalSize();
        }, 100);
      })
      .catch((err) => {
        console.error(err);
      });
    return this.modalInstance.result;
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/filter-editor-modal.service.js